<template>
  <div class="app ma-4">
    <div class="text-h4">Relatórios de Disponibilidade</div>
    <v-tabs v-model="tabs" background-color="background" class="fixed-tabs-bar">
      <v-tab v-for="n in tipos" :key="n">
        {{ tipo[n - 1] }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs" class="app">
      <v-tab-item>
        <RelatorioDisponibilidadeResumido />
      </v-tab-item>
      <v-tab-item>
        <RelatorioDisponibilidadeDetalhado />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import RelatorioDisponibilidadeResumido from '../_components/disponibilidadeResumido/_views/RelatorioDisponibilidadeResumido'
import RelatorioDisponibilidadeDetalhado from '../_components/disponibilidadeDetalhado/_views/RelatorioDisponibilidadeDetalhado'
export default {
  name: 'RelatoriosDisponibilidade',
  components: { RelatorioDisponibilidadeResumido, RelatorioDisponibilidadeDetalhado },
  data: () => ({
    tabs: 2,
    tipos: 2,
    tipo: ['Resumido', 'Detalhado'],
  }),
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
.fixed-tabs-bar {
  position: -webkit-sticky;
  position: sticky;
  top: 48px;
  z-index: 15;
}
</style>
